var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15ZM7.58333 3.16667C7.99755 3.16667 8.33333 3.50246 8.33333 3.91667V9.34531L10.5543 7.13506C10.8479 6.84288 11.3228 6.84402 11.6149 7.13762C11.9071 7.43122 11.906 7.90609 11.6124 8.19828L8.09544 11.6983C7.95445 11.8386 7.76349 11.9171 7.56458 11.9167C7.36567 11.9162 7.17509 11.8367 7.03478 11.6957L3.55172 8.19571C3.25954 7.90211 3.26069 7.42724 3.55429 7.13505C3.84789 6.84287 4.32277 6.84402 4.61495 7.13763L6.83333 9.3668V3.91667C6.83333 3.50246 7.16912 3.16667 7.58333 3.16667Z","fill":"#FF007F"}));
}

ArrowDown.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
